import Channels from '../../base/channels'
import Env from '../../base/env'

export default class SlideshowCompo
{
    constructor(view)
    {
        this.view = view
        this.$textBottom = this.view.querySelector('.jsBottom')
        this.$textTop = this.view.querySelector('.jsTop')
        this.funcSizer = this.resize.bind(this)
    }

    destroy()
    {
        Channels.removeListener('window::smartresize',this.funcSizer)
    }

    events()
    {
        Channels.on('window::smartresize',this.funcSizer)
    }

    resize()
    {
        this.sizeTexts()
    }

    sizeTexts()
    {
        if(Env.mobileCSS == false) {
            if(this.$textBottom != null) {
                this.$textBottom.removeAttribute('style')
                const dimensionsBottom = this.$textBottom.getBoundingClientRect()
                this.$textBottom.style.top = `${dimensionsBottom.height * -1}px`
                this.$textBottom.style.marginBottom = `${dimensionsBottom.height * -1}px`

            }
            if(this.$textTop != null) {
                this.$textTop.removeAttribute('style')
                const dimensionsTop = this.$textTop.getBoundingClientRect()
                this.$textTop.style.top = `${dimensionsTop.height}px`
                this.$textTop.style.marginTop = `${dimensionsTop.height * -1}px`

            }
        } else {
            if(this.$textBottom != null) {
                this.$textBottom.removeAttribute('style')
            }
            if(this.$textTop != null) {
                this.$textTop.removeAttribute('style')
            }
        }

    }

    setup()
    {
        this.sizeTexts()
        this.events()
    }
}